// removed by extract-text-webpack-plugin
module.exports = {"linkButton":"style__linkButton___3iHzI","icon":"style__icon___19tVh"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/linkButton/style.scss
 ** module id = 363
 ** module chunks = 0
 **/